import {
  useEffect,
  useState,
} from 'react';

import { mediaQueriesNum } from '@/utils/mediaQueries';

const {
  small,
  tablet,
} = mediaQueriesNum;

export const useResponsiveMaxLength = (): number => {
  const [
    maxLength,
    setMaxLength,
  ] = useState(100);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= small) {
        setMaxLength(100);
      } else if (window.innerWidth <= tablet) {
        setMaxLength(300);
      } else {
        setMaxLength(1000);
      }
    };

    // Set initial value
    handleResize();

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return maxLength;
};
